import {InviteUser, UserId, CreateServiceUser, UserApikeyId, ProductType} from "platformed-client/types";
import {invalidateQueries, q, setQueryData} from "../state";
import {platformedClient} from ".";

export async function listAccountUsers(product: ProductType) {
  const res = await platformedClient.internalRequest("get", "/region/{region}/api/users", {path: {}, query: {product}});

  // Pre-populate users
  for (const {user} of res) {
    setQueryData(q.user(user.user_id), {
      user_id: user.user_id,
      name: user.name,
      primary_email: user.primary_email,
      avatar_url: user.avatar_url,
    });
  }

  return res;
}

export async function get(userId: UserId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/users/{user_id}", {
    path: {user_id: userId},
  });
}

export async function getTeams(userId: UserId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/users/{user_id}/teams", {
    path: {user_id: userId},
  });
}

export async function createService(user: CreateServiceUser) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/service_users", {
    path: {},
    body: user,
  });
  await invalidateQueries([q.accountUsers.filter()]);
  return res;
}

export async function createServiceApikey(userId: UserId) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/service_users/{user_id}/apikeys", {
    path: {user_id: userId},
  });
  await invalidateQueries([q.serviceUserApikeys.filter(userId)]);
  return res;
}

export async function listServiceApikeys(userId: UserId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/service_users/{user_id}/apikeys", {
    path: {user_id: userId},
  });
}

export async function deleteServiceApikey(userId: UserId, userApikeyId: UserApikeyId) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/service_users/{user_id}/apikeys/{user_apikey_id}",
    {path: {user_id: userId, user_apikey_id: userApikeyId}},
  );
  await invalidateQueries([q.serviceUserApikeys.filter(userId)]);
  return res;
}

export async function invite(user: InviteUser) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/registered_users/invite", {
    path: {},
    body: user,
  });
  await invalidateQueries([
    q.vendorToolkit.gettingStartedChecklist.filter(),
    q.accountUsers.filter(),
    q.roles.filter(),
    q.roleMembers.filter(),
    q.teams.filter(),
    q.userTeams.filter(),
  ]);
  return res;
}

export async function remove(userId: UserId): Promise<string> {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/users/{user_id}", {
    path: {user_id: userId},
  });
  await invalidateQueries([q.accountUsers.filter(), q.owner.filter(), q.resolvedOwner.filter()]);
  return res;
}
